import { Typography } from "@mui/material";
import { Box } from "@mui/system";

interface IProps {
  data?: {
    google2fa_code: string;
    google2fa_qrcode: string;
  },
  code?: string;
  setCode: (code: string) => void;
}

export default function DownloadApp(props: IProps) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200,
      }}
    >
      {["download-apple", "download-google"].map((icon, index) => (
        <a key={index} style={{ textDecoration: "none", color: "unset" }} target="_blank" href={icon === "download-apple" ? "https://apps.apple.com/us/app/google-authenticator/id388497605" : "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              border: "1px solid #eceaef",
              maxWidth: "250px",
              width: "100%",
              padding: "12px 20px",
              transition: "all 0.3s ease-in-out",
              ":hover": {
                transition: "all 0.3s ease-in-out",
                backgroundColor: "#eceaef",
                "p:last-child": {
                  textDecoration: "underline"
                }
              }
            }}
          >
            <img src={require(`../../../../assets/${icon}.svg`)} alt="icon" style={{ width: 30 }} />
            <Box>
              <Typography variant="body1" sx={{ fontWeight: "500", fontSize: "16px" }}>
                Download From
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "500" }}>
                {icon === "download-apple" ? "App Store" : "Google Play"}
              </Typography>
            </Box>
          </Box>
        </a>
      ))}
    </Box>
  )
}